import { FC, MouseEventHandler, PropsWithChildren, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import {
  editFormDataAF,
  IRideDto,
  NO_VALUE_DISPLAY,
  RideCrudModeKeyTuple,
  useIsMobile,
} from "@ryde/shared";

import {
  LayoutRightHeaderStartButtonsStyled,
  LayoutRightHeaderTitleStyled,
} from "../../../../right";
import { RideHeaderButtons } from "./ride-header-buttons";
import { RideHeaderInfosLine1 } from "./ride-header-infos-line1";
import { RideHeaderInfosLine2 } from "./ride-header-infos-line2";
import { HeaderLine1Styled, RideHeaderStyled } from "./ride-header.styled";

interface IRideHeaderProps extends PropsWithChildren {
  closeClick?: MouseEventHandler<Element>;
}

export const RideHeader: FC<IRideHeaderProps> = ({ closeClick }) => {
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();
  const rideDto = useRecoilValue<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );

  const headerTitleTextMobile = useMemo(() => {
    return rideDto?.courseId ? t(`general.FIXED_COURSE`) : "";
  }, [rideDto?.courseId, t]);

  return (
    <RideHeaderStyled className="RideDrawer-Header">
      <LayoutRightHeaderStartButtonsStyled>
        {closeClick && (
          <SVG_MUI.XMarkSVG onClick={closeClick} className="close" />
        )}
      </LayoutRightHeaderStartButtonsStyled>
      {isMobile && (
        <HeaderLine1Styled>
          <h2 data-e2e="ride-header-mobile-text">
            {headerTitleTextMobile}
            <span className="ride-id-mobile">
              {rideDto?.id || NO_VALUE_DISPLAY}
            </span>
          </h2>
        </HeaderLine1Styled>
      )}
      {!isMobile && (
        <LayoutRightHeaderTitleStyled className="RideDrawer-HeaderTitle">
          <RideHeaderInfosLine1 />
          <RideHeaderInfosLine2 />
        </LayoutRightHeaderTitleStyled>
      )}
      <RideHeaderButtons />
    </RideHeaderStyled>
  );
};
